export default function createMediaData(formData, sendData) {
  for (const key in sendData) {
    formData.append(key, sendData[key]);
  }
}
